
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherSalesDetailsGrid extends Serenity.EntityGrid<GiftVoucherSalesDetailsRow, any> {
        protected getColumnsKey() { return 'Retail.GiftVoucherSalesDetails'; }
        protected getDialogType() { return GiftVoucherSalesDetailsDialog; }
        protected getIdProperty() { return GiftVoucherSalesDetailsRow.idProperty; }
        protected getInsertPermission() { return GiftVoucherSalesDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return GiftVoucherSalesDetailsRow.localTextPrefix; }
        protected getService() { return GiftVoucherSalesDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}